import {
    Directive,
    ElementRef,
    Input,
    Renderer2,
    inject
} from "@angular/core";
import { AbstractControl, NgControl, ValidatorFn } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { ValidationRuleController } from "./ValidationRuleController";

@Directive({ selector: "[raskValidationRule]" })
export class ValidationRuleMessageDirective {
    control = inject(NgControl, { self: true });
    errorTextElement: any;
    initvalidation = false;
    validationRule: ValidationRuleController;

    private readonly element = inject(ElementRef);
    private readonly renderer = inject(Renderer2);
    private readonly translate = inject(TranslateService);

    // eslint-disable-next-line @angular-eslint/no-input-rename
    @Input("initialValidation") set initialValidation(val: boolean) {
        this.initvalidation = val;
    }

    @Input("raskValidationRule") set rule(val: ValidationRuleController) {
        this.validationRule = val;
        this.init();
    }

    init() {
        setTimeout(() => {
            if (this.validationRule != null && this.control != null) {
                const validationFn = this.createValidateFn();
                this.control.control.setValidators([validationFn]);
                const texts = this.validationRule.rules.map(x => x.settings.message.text);
                this.createErrorTexts(texts);
                if (this.initvalidation) {
                    this.control.control.updateValueAndValidity({ onlySelf: true });
                }
            } else {
                console.error(`[raskValidationRule]: validationRule or control not found. rule: ${this.validationRule ? this.validationRule.name : ""}`);
                console.error(this.control);
            }
        });
    }

    private createErrorTexts(texts: string[]) {
        this.errorTextElement = this.renderer.createElement("small");
        this.renderer.addClass(this.errorTextElement, "text-danger");
        const text = this.renderer.createText(this.translateTexts(texts).join(". "));
        this.renderer.appendChild(this.errorTextElement, text);
        this.renderer.appendChild(this.element.nativeElement.parentNode, this.errorTextElement);
        if (!this.initvalidation) {
            this.setErrorsVisible(false);
        }
    }

    private createValidateFn(): ValidatorFn {
        return (currentControl: AbstractControl): { [key: string]: any } | null => {
            const invalid = this.validationRule.rules.some(x => x.validate(currentControl.value, x.originalValue) === false);
            const returnValue = {};
            returnValue[this.validationRule.name] = invalid;
            this.setErrorsVisible(invalid);
            return invalid === false ? null : returnValue;
        };
    }

    private setErrorsVisible(visible: boolean): void {
        // eslint-disable-next-line sonarjs/no-selector-parameter
        if (visible) {
            this.renderer.removeAttribute(this.errorTextElement, "hidden");
        } else {
            this.renderer.setAttribute(this.errorTextElement, "hidden", "true");
        }
    }

    private translateTexts(texts: string[]): string[] {
        return texts.map(t => this.translate.instant(t));
    }
}
